import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ArmazenamentoDeTokenService } from 'src/app/shared/services/armazenamento/armazenamento-de-token.service';

@Injectable({
  providedIn: 'root',
})
export class AutorizacaoGuard implements CanActivate {
  constructor(
    private armazenamentoDeTokenService: ArmazenamentoDeTokenService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const token = this.armazenamentoDeTokenService.buscarToken();

    if (!token) {
      return this.router.createUrlTree(['/auth/login'], {
        queryParams: { callback: 'acesso-requer-login' },
      });
    }

    return true;
  }
}
